import React, { useEffect, useState } from "react";
import { authService } from "../services/authService";

interface Props {
  children: React.ReactNode;
}

export const AuthInitializer: React.FC<Props> = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await authService.fetchAuthenticatedUser();
      } catch {
        // הטיפול ב-401 מתבצע ב-interceptor
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return <>{children}</>;
};
